import ActionTypes from 'core/actions/actionTypes';
import initialState from 'core/reducers/initialState';

function actionSuccessful(type) {
	return getActionType(type).substring(type.length - 8) === '_SUCCESS';
}

function getActionType(type: any) {
	if(typeof type === "string") {
		return type;
	}
	return ActionTypes[type];
}

export default function ajaxStatusReducer(state = initialState.params.global.ajaxCallsInProgress, action) {
	if (action.type === ActionTypes.AJAX_CALL_BEGIN) {
		return state + 1;
	} else if (action.type === ActionTypes.AJAX_CALL_ERROR || actionSuccessful(action.type)) {
		return state - 1;
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/core/reducers/ajax/ajaxStatusReducer.ts